'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _create = require('babel-runtime/core-js/object/create');

var _create2 = _interopRequireDefault(_create);

exports.default = init;

var _helpers = require('./_helpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GiftMessage = {
  init: function init(_ref) {
    var el = _ref.el,
        context = _ref.context;

    this.context = context;
    this.els = {
      el: el,
      giftMsgButton: context.getElement('.' + context.className + '_Button'),
      giftMsgButtonAdd: context.getElement('.' + context.className + '_Add'),
      giftMsgButtonUpdate: context.getElement('.' + context.className + '_Update'),
      giftMsgButtonCancel: context.getElement('.' + context.className + '_Cancel'),
      giftMsgTextarea: context.getElement('.' + context.className + '_Textarea'),
      giftMsgCharacterLimit: context.getElement('.' + context.className + '_CharacterCount'),
      giftMsgSave: context.getElement('.' + context.className + '_ButtonSave'),

      // The input is not within the context
      noteInput: document.querySelector('.' + context.className + '_Input')
    };

    this.initialcharacterLimit = parseInt(this.els.giftMsgTextarea.getAttribute('maxlength'));
    this.remainingCharacterLimit = this.initialcharacterLimit;

    this.listeners = (0, _create2.default)(_helpers.Listeners);

    this.methods.copyTextToInput = this.methods.copyTextToInput.bind(this);
    this.methods.emptyInput = this.methods.emptyInput.bind(this);
    this.methods.updateCharacterCount = this.methods.updateCharacterCount.bind(this);

    this.setupListeners();
  },

  setupListeners: function setupListeners() {
    var _this = this;

    this.els.giftMsgButton.addEventListener('click', function (e) {
      var isExpanded = _this.els.el.getAttribute('aria-expanded');

      if (isExpanded === 'true') {
        _this.els.el.setAttribute('aria-expanded', 'false');
        _this.els.giftMsgButtonAdd.setAttribute('aria-hidden', 'false');
        _this.els.giftMsgButtonUpdate.setAttribute('aria-hidden', 'true');
        _this.els.giftMsgButtonCancel.setAttribute('aria-hidden', 'true');

        _this.methods.emptyInput();
      } else {
        _this.els.el.setAttribute('aria-expanded', 'true');
        _this.els.giftMsgButtonAdd.setAttribute('aria-hidden', 'true');
        _this.els.giftMsgButtonUpdate.setAttribute('aria-hidden', 'true');
        _this.els.giftMsgButtonCancel.setAttribute('aria-hidden', 'false');
      }
    });

    // Copy the text as the customer types
    this.els.giftMsgTextarea.addEventListener('input', function (e) {
      _this.methods.copyTextToInput(e.target.value);
    });
    // Copy the text when focus leaves the textarea
    this.els.giftMsgTextarea.addEventListener('blur', function (e) {
      _this.methods.copyTextToInput(e.target.value);
    });

    window.addEventListener('load', function (e) {
      _this.methods.updateCharacterCount(_this.els.giftMsgTextarea.value);
    });

    this.els.giftMsgSave.addEventListener('click', function (e) {
      e.preventDefault();

      _this.els.el.setAttribute('aria-expanded', 'false');
      _this.els.giftMsgButtonAdd.setAttribute('aria-hidden', 'true');
      _this.els.giftMsgButtonUpdate.setAttribute('aria-hidden', 'false');
      _this.els.giftMsgButtonCancel.setAttribute('aria-hidden', 'true');
    });
  },


  methods: {
    copyTextToInput: function copyTextToInput(value) {
      this.els.noteInput.value = value;

      this.methods.updateCharacterCount(value);
    },
    emptyInput: function emptyInput() {
      this.els.giftMsgTextarea.innerText = '';
      this.els.giftMsgTextarea.value = '';
      this.els.noteInput.value = '';

      this.methods.updateCharacterCount('');
    },
    updateCharacterCount: function updateCharacterCount(value) {
      var charactersRemaining = this.initialcharacterLimit - value.length;
      var characterLimitText = this.els.giftMsgCharacterLimit.innerText.replace(this.remainingCharacterLimit.toString() + ' of', charactersRemaining.toString() + ' of');

      this.els.giftMsgCharacterLimit.innerText = characterLimitText;
      this.remainingCharacterLimit = charactersRemaining;
    }
  }
};

function init(_ref2) {
  var el = _ref2.el,
      context = _ref2.context;

  var giftMessage = (0, _create2.default)(GiftMessage);
  giftMessage.init({ el: el, context: context });
}